import { type PropsWithChildren, type ReactElement } from 'react';

import type { ProviderSlotProp } from '../types/chart-layout.js';

type ProviderProps = (
  props: PropsWithChildren<{
    provider: ProviderSlotProp;
  }>,
) => ReactElement | null;

export const Provider: ProviderProps = () => null;

(Provider as typeof Provider & { displayName: string }).displayName =
  'ChartLayout.Provider';
